import React, { Component } from 'react';

import DayPicker, { DateUtils } from 'react-day-picker';
import TimePicker from './TimePicker';
import { getLang } from  './TimePicker';

import { Input } from 'reactstrap';

import timezones from '../../utils/timezones';

import map from 'lodash/map';


class DateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.changeFromTime = this.changeFromTime.bind(this);
    this.changeToTime = this.changeToTime.bind(this);
    this.changeTimezone = this.changeTimezone.bind(this);
    
    this.state = this.getInitialState();
  }
  
  getInitialState() {
    const today = new Date();
    var disableBefore =  new Date();
    disableBefore.setHours(0,0,0,0);
    
    const locale = getLang();
    
    const { start_at, end_at, timezone } = this.props.value || {};
    let initFrom = start_at && this.initDateInTz(start_at, timezone);
    let initTo = end_at && this.initDateInTz(end_at, timezone);
    
    return {
      from: initFrom,
      to: initTo,
      enteredTo: initTo, // Keep track of the last day for mouseEnter.
      disableBefore: disableBefore,
      timezone: timezone || parseFloat(today.getTimezoneOffset()) / -60,
      defaultTime: [(initFrom || today).getHours(), (initFrom || today).getMinutes()],
      locale
    };
  }
  
  initDateInTz (d, offset){
    let date = new Date(d);
    const localOffset = date.getTimezoneOffset();
    if (offset && offset * -60 !== localOffset){
      const localTime = date.getTime();
      const resOffset = ((offset * -60) - localOffset) * 60000;
      date = new Date(localTime - resOffset);
    }
    return date;
  }
  
  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }
  
  handleDayClick(day) {
    const { from, to, disableBefore, defaultTime } = this.state;
    
    if ( day < disableBefore)
      return;
    
    day.setHours(defaultTime[0]);
    day.setMinutes(defaultTime[1]);
    
    if (from && to && day >= from && day <= to) {
      // day.setHours(from.getHours());
      // day.setMinutes(from.getMinutes());
      // this.setState({from: day}, this.update);
      this.handleResetClick();
      return;
    }
    if (this.isSelectingFirstDay(from, to, day)) {
      this.setState({
        from: day,
        to: null,
        enteredTo: null,
      }, this.update);
    } else {
      this.setState({
        to: day,
        enteredTo: day,
      }, this.update);
    }
  }
  
  handleDayMouseEnter(day) {
    const { from, to } = this.state;
    if (!this.isSelectingFirstDay(from, to, day)) {
      this.setState({
        enteredTo: day,
      });
    }
  }
  
  handleResetClick() {
    this.setState({
      from: null,
      to: null,
      enteredTo: null
    }, this.update);
  }
  
  changeFromTime(from) {
    this.setState({from}, this.update);
  }
  changeToTime(to) {
    this.setState({to}, this.update);
  }
  
  changeTimezone (e){
    const timezone = e.target.value;
    this.setState({timezone}, this.update);
  }
  
  
  toISOTime (d, offset){
    const localTime = d.getTime();
    const localOffset = ((offset * -60) - d.getTimezoneOffset()) * 60000;
    const utc = localTime + localOffset;
    
    return new Date(utc).toJSON();
  }
  
  getValues () {
    const { from, to, timezone} = this.state;
    return {
      start_at: from && this.toISOTime(from, timezone),
      end_at: to && this.toISOTime(to, timezone),
      timezone
    };
  }
  
  async update () {
    const { from, to } = this.state;
    if ( to && to.getTime() < from.getTime() + 60000 )
      await this.setState({to: new Date(from.getTime() + 15 * 60000)});
    
    const { onChange } = this.props;
    onChange && onChange(this.getValues());
  }
  
  render() {
    const { from, to, enteredTo, disableBefore, timezone, locale } = this.state;
    const modifiers = { start: from, end: enteredTo };
    const disabledDays = { before: this.state.from || disableBefore };
    const selectedDays = [from, { from, to: enteredTo }];
    
    return (
      <div style={{textAlign: 'center', maxWidth: "500px", margin: "0 auto"}}>
        <DayPicker
          className="date-range-picker"
          numberOfMonths={1}
          fromMonth={from}
          selectedDays={selectedDays}
          disabledDays={disabledDays}
          modifiers={modifiers}
          onDayClick={this.handleDayClick}
          onDayMouseEnter={this.handleDayMouseEnter}
        />
        
        <div className="date-time-range-input">
          <div className="input-stack form-group">
            <div className="input-group input-stack-row">
              <div className="input-group-label">Start at</div>
              <Input value={(from && from.toLocaleDateString(locale)) || ''} disabled placeholder="Please select the start day" />
              {from && <TimePicker locale={locale} value={from} onChange={this.changeFromTime} />}
            </div>
            <div className="input-group input-stack-row">
              <div className="input-group-label">End at</div>
              <Input value={(to && to.toLocaleDateString(locale)) || ''} disabled placeholder="Please select the end day" />
              {to && <TimePicker locale={locale} value={to} onChange={this.changeToTime} />}
            </div>
          </div>
          
          <div className="input-group form-group">
            <div className="input-group-label">Time zone</div>
            <select className="form-control" onChange={this.changeTimezone} value={timezone}>
              {map(timezones, (tz) => <option key={tz.value} value={tz.value}>{tz.text}</option>)}
            </select>
          </div>
          
          {false && from &&
            to &&
            `Selected from ${from.toLocaleDateString()} to
                ${to.toLocaleDateString()}`}{' '}
          {false && from && to && (
            <button className="link" onClick={this.handleResetClick}>
              Reset
            </button>
          )}
        </div>
      </div>
    );
  }
};

export default DateRangePicker;


// WEBPACK FOOTER //
// ./src/components/helpers/DateRangePicker.js